import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, FileText } from 'lucide-react';
interface TermsAndConditionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsAndConditionsModal({
  isOpen,
  onClose
}: TermsAndConditionsModalProps) {
  return <AnimatePresence data-id="element-285">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[60] flex items-center justify-center p-4" data-id="element-286">
            {/* Modal Container */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-4xl max-h-[90vh] flex flex-col bg-gaming-card border border-gaming-cyan/30 rounded-xl shadow-[0_0_50px_rgba(0,217,255,0.15)] overflow-hidden" data-id="element-287">
              {/* Header */}
              <div className="p-6 border-b border-white/10 flex justify-between items-center bg-gaming-dark/95 backdrop-blur sticky top-0 z-10" data-id="element-288">
                <div className="flex items-center gap-3" data-id="element-289">
                  <FileText className="w-6 h-6 text-gaming-cyan" data-id="element-290" />
                  <h2 className="text-xl md:text-2xl font-bold font-display text-white uppercase tracking-wide" data-id="element-291">
                    Términos y{' '}
                    <span className="text-gaming-cyan" data-id="element-292">Condiciones</span>
                  </h2>
                </div>
                <button onClick={onClose} className="text-gray-400 hover:text-white hover:bg-white/10 p-2 rounded-full transition-colors" data-id="element-293">
                  <X className="w-6 h-6" data-id="element-294" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="flex-1 overflow-y-auto p-6 md:p-8 space-y-8 text-gray-300 leading-relaxed" data-id="element-295">
                <div className="text-center mb-6" data-id="element-296">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-297">
                    Términos y Condiciones de Uso
                  </h3>
                  <p className="text-gaming-cyan" data-id="element-298">APP y tarjeta LevelUp Play</p>
                </div>

                {/* Section 1 */}
                <section data-id="element-299">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-300">
                    <span className="text-gaming-cyan" data-id="element-301">1.</span> NATURALEZA DEL
                    PROGRAMA
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5" data-id="element-302">
                    <p data-id="element-303">
                      El presente documento establece los términos y condiciones
                      aplicables al uso de la tarjeta de fidelización gratuita
                      denominada LevelUp Play (en adelante, "la Tarjeta"), la
                      cual permite a sus titulares acceder a beneficios,
                      descuentos y promociones ofrecidos por comercios afiliados
                      al programa.
                    </p>
                  </div>
                </section>

                {/* Section 2 */}
                <section data-id="element-304">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-305">
                    <span className="text-gaming-cyan" data-id="element-306">2.</span> ACCESO A LA
                    TARJETA
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5 space-y-3" data-id="element-307">
                    <p data-id="element-308">
                      La Tarjeta es gratuita y de uso personal e intransferible.
                    </p>
                    <p data-id="element-309">
                      Podrá acceder a ella cualquier persona natural mayor de
                      edad que complete el formulario de afiliación
                      correspondiente.
                    </p>
                    <p data-id="element-310">
                      El uso de la Tarjeta implica la aceptación plena de estos
                      términos y condiciones.
                    </p>
                  </div>
                </section>

                {/* Section 3 */}
                <section data-id="element-311">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-312">
                    <span className="text-gaming-cyan" data-id="element-313">3.</span> BENEFICIOS Y
                    PROMOCIONES
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5 space-y-3" data-id="element-314">
                    <p data-id="element-315">
                      Los beneficios ofrecidos pueden incluir: descuentos
                      directos, promociones especiales, servicios
                      preferenciales, obsequios u otros incentivos, según lo
                      determine cada comercio afiliado.
                    </p>
                    <p data-id="element-316">
                      Cada comercio es el único responsable de aplicar,
                      mantener, modificar o cancelar los beneficios que ofrece a
                      los usuarios de la Tarjeta.
                    </p>
                    <p data-id="element-317">
                      Los beneficios están sujetos a condiciones particulares
                      propias de cada comercio (vigencia, stock, montos mínimos
                      de compra, restricciones, etc.).
                    </p>
                  </div>
                </section>

                {/* Section 4 */}
                <section data-id="element-318">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-319">
                    <span className="text-gaming-cyan" data-id="element-320">4.</span> RESPONSABILIDAD
                    DEL PROGRAMA
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5 space-y-3" data-id="element-321">
                    <p data-id="element-322">
                      TicketMaestro y su plataforma Benefika, empresa
                      procesadora de La Tarjeta, actúa únicamente como
                      intermediario que conecta a los usuarios con comercios
                      aliados, sin asumir responsabilidad por la calidad,
                      disponibilidad o condiciones de los productos o servicios
                      ofrecidos.
                    </p>
                    <p data-id="element-323">
                      En caso de cualquier inconveniente o reclamo relacionado
                      con los beneficios, el usuario deberá comunicarse
                      directamente con el comercio correspondiente.
                    </p>
                  </div>
                </section>

                {/* Section 5 */}
                <section data-id="element-324">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-325">
                    <span className="text-gaming-cyan" data-id="element-326">5.</span> VIGENCIA Y
                    MODIFICACIONES
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5 space-y-3" data-id="element-327">
                    <p data-id="element-328">
                      La vigencia de la Tarjeta es indefinida, salvo que el
                      usuario o la organización emiten renuncien expresamente a
                      su uso.
                    </p>
                    <p data-id="element-329">
                      La organización se reserva el derecho de modificar,
                      suspender o cancelar el programa o sus términos y
                      condiciones, informando oportunamente a los usuarios a
                      través de sus canales oficiales.
                    </p>
                  </div>
                </section>

                {/* Section 6 */}
                <section data-id="element-330">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-331">
                    <span className="text-gaming-cyan" data-id="element-332">6.</span> PROTECCIÓN DE
                    DATOS PERSONALES
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5 space-y-3" data-id="element-333">
                    <p data-id="element-334">
                      Al afiliarse, el usuario autoriza el tratamiento de sus
                      datos personales conforme a la legislación vigente,
                      exclusivamente para fines informativos y promocionales
                      relacionados con el programa.
                    </p>
                    <p data-id="element-335">
                      Los datos no serán compartidos con terceros sin
                      consentimiento del titular, salvo requerimiento legal.
                      Puede ver más detalles en el documento de nuestras
                      Políticas de Privacidad y Protección de Datos Personales.
                    </p>
                  </div>
                </section>

                {/* Section 7 */}
                <section data-id="element-336">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-337">
                    <span className="text-gaming-cyan" data-id="element-338">7.</span> USO INDEBIDO Y
                    CANCELACIÓN
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5 space-y-3" data-id="element-339">
                    <p data-id="element-340">
                      El uso fraudulento, indebido o contrario a estos términos
                      puede dar lugar a la anulación inmediata de la Tarjeta y
                      la pérdida de sus beneficios.
                    </p>
                    <p data-id="element-341">
                      La organización podrá retirar o suspender la tarjeta en
                      caso de mal uso sin necesidad de notificación previa.
                    </p>
                  </div>
                </section>

                {/* Section 8 */}
                <section data-id="element-342">
                  <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-343">
                    <span className="text-gaming-cyan" data-id="element-344">8.</span> VIGENCIA
                  </h3>
                  <div className="pl-4 border-l-2 border-white/5" data-id="element-345">
                    <p data-id="element-346">
                      La vigencia de estos Términos y Condiciones de Uso es
                      desde el 12 de septiembre de 2025 y permanecerá vigente
                      hasta que exista una nueva versión que la reemplace.
                    </p>
                  </div>
                </section>
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-white/10 bg-gaming-dark/95 backdrop-blur flex justify-end" data-id="element-347">
                <button onClick={onClose} className="px-6 py-3 bg-gaming-cyan/10 text-gaming-cyan border border-gaming-cyan/50 font-bold rounded hover:bg-gaming-cyan/20 transition-all uppercase tracking-wide" data-id="element-348">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}